export default class Polygon {
  constructor(map, coords, options = {}) {
    this.map = map
    this.options = options
    this.coords = coords

    this.points = []
    this.bound = new window.google.maps.LatLngBounds()

    this.coords.map((coords) => {
      const point = new window.google.maps.LatLng(coords.lat, coords.lng)
      this.points.push(point)
      this.bound.extend(point)
    })

    // Polygons options
    const opts = {
      paths: this.points,
      strokeColor: this.options.strokeColor || '#0069B1',
      strokeOpacity: this.options.strokeOpacity || 0.8,
      strokeWeight: this.options.strokeHeight || 2,
      fillColor: this.options.fillCol || '#fff',
      fillOpacity: this.options.fillOpacit | 0.05,
    }

    // Create Polygon object
    this.overlay = new window.google.maps.Polygon(opts)

    // Set the overlay on the map
    this.overlay.setMap(this.map)

    // EVENTS
    window.google.maps.event.addListener(
      this.overlay,
      'click',
      this.handleClick.bind(this),
    )
  }

  show() {
    this.overlay.setMap(this.map)
  }
  hide() {
    this.overlay.setMap(null)
  }

  handleClick() {
    // Get the center of the polygon
    const center = this.bound.getCenter()

    // Pan to the center of the polygon
    this.map.panTo(center)
  }
}
